export const SEO_ROUTES = {
    "/": {
        title: "Julians Gartenservice | Heckenschnitt, Pflasterreinigung & Gartenpflege in Celle",
        desc: "Professionelle Gartenpflege & Außenreinigung im Landkreis Celle: Heckenschnitt, Pflasterreinigung, Rasenpflege & Rasenreparatur und Laubentfernung. Kostenloses Festpreis-Angebot anfragen.",
    },
    "/heckenschnitt-celle": {
        title: "Heckenschnitt in Celle | Formschnitt & Rückschnitt – Julians Gartenservice",
        desc: "Professioneller Heckenschnitt im Landkreis Celle: Formschnitt, Rückschnitt und Heckenpflege für Thuja, Liguster, Kirschlorbeer u. a. – inklusive Schnittgut-Entsorgung. Festpreis-Angebot anfragen.",
    },
    "/hochdruckreinigung-celle": {
        title: "Hochdruckreinigung & Pflasterreinigung in Celle | Julians Gartenservice",
        desc: "Hochdruckreinigung im Landkreis Celle: Terrassen, Einfahrten, Gehwege und Pflasterflächen materialschonend von Grünbelag, Moos und Unkraut befreit. Mit echten Vorher/Nachher-Bildern.",
    },
    "/rasenpflege-celle": {
        title: "Rasenpflege in Celle | Mähen, Vertikutieren & Reparatur – Julians Gartenservice",
        desc: "Regelmäßige Rasenpflege im Landkreis Celle: Mähen, Kantenschneiden, Vertikutieren, Nachsaat und Reparatur lückenhafter Rasenflächen. Zuverlässige Termine, Festpreis-Angebot.",
    },
    "/gartenpflege-celle": {
        title: "Gartenpflege in Celle | Gartenservice & Grundstückspflege – Julians Gartenservice",
        desc: "Gartenpflege und Grundstückspflege im Landkreis Celle: Beetpflege, Unkraut- und Laubentfernung, Strauchschnitt und regelmäßige Betreuung für Privat, Vermieter und Gewerbe.",
    },
    "/referenzen": {
        title: "Referenzen & Vorher-Nachher-Projekte | Julians Gartenservice Celle",
        desc: "Echte Projekte aus dem Landkreis Celle: Pflasterreinigung und Heckenschnitt im Vorher/Nachher-Vergleich sowie Einblicke in die Arbeit von Julians Gartenservice.",
    },
    "/ueber-mich": {
        title: "Über mich – Julian Kosinski | Julians Gartenservice in Celle",
        desc: "Julian Kosinski, Inhaber von Julians Gartenservice: persönliche Betreuung, professionelle Technik und verlässliche Gartenpflege im Landkreis Celle – von der Anfrage bis zur Ausführung.",
    },
    "/angebot": {
        title: "Kostenloses Angebot anfragen | Julians Gartenservice Celle",
        desc: "Angebot für Heckenschnitt, Pflasterreinigung, Rasenpflege oder Gartenpflege im Landkreis Celle anfragen – kurzes Formular, optional mit Foto, Antwort in der Regel innerhalb von 24 Stunden.",
    },
    "/impressum": {
        title: "Impressum | Julians Gartenservice",
        desc: "Impressum von Julians Gartenservice, Julian Kosinski, Sankt-Georg-Garten 6/3, 29221 Celle.",
    },
    "/datenschutz": {
        title: "Datenschutzerklärung | Julians Gartenservice",
        desc: "Datenschutzerklärung von Julians Gartenservice, Celle – Informationen zur Verarbeitung Ihrer Daten bei Anfragen.",
    },
};
